import { CSV_DATA_FILTER_TYPE } from "../csvDataFilterTypes";
import FilterOptionsHelper from "./FilterOptionsHelper";

export default class ApiHelper {
  static getColumnAttributeForFiltering(column) {
    return column.filtering_attribute_name || column.attribute_name;
  }

  static getColumnAttributeForSorting(column) {
    return column.sorting_attribute_name || column.attribute_name;
  }

  static compareColumnAttributeName(column, attributeName) {
    return (
      column.data_management_attribute_name === attributeName ||
      column.attribute_name === attributeName
    );
  }

  static compareColumnAttributeNameForFiltering(column, attributeName) {
    return (
      column.filtering_attribute_name === attributeName ||
      column.attribute_name === attributeName
    );
  }

  static compareColumnAttributeNameForSorting(column, attributeName) {
    return (
      column.sorting_attribute_name === attributeName ||
      column.attribute_name === attributeName
    );
  }

  static getIsSortable(column) {
    if (column.sorting_attribute_name === null) {
      return false;
    }

    return (
      column.values_type !== "generated_in_frontend" ||
      !!column.sorting_attribute_name
    );
  }

  static getIsSearchable(column) {
    return (
      (column.values_type === "string" || !!column.filtering_attribute_name) &&
      column.filter_type === CSV_DATA_FILTER_TYPE.SEARCH
    );
  }

  static getIsDynamicAutocomplete(column) {
    return (
      column?.filter_type === CSV_DATA_FILTER_TYPE.DYNAMIC_AUTOCOMPLETE &&
      typeof column?.filter_data?.url === "string" &&
      column.filter_data.url.length > 0
    );
  }

  static getIsFilterableByRange(column) {
    return (
      column.filter_type === CSV_DATA_FILTER_TYPE.RANGE &&
      column.filter_data.min !== null &&
      column.filter_data.max !== null
    );
  }

  static getIsFilterableByValueSet(column) {
    return (
      column.filter_type === CSV_DATA_FILTER_TYPE.VALUES &&
      Array.isArray(column.filter_data) &&
      column.filter_data.length > 0
    );
  }

  static getIsFilterableByRadio(column) {
    return (
      column.filter_type === CSV_DATA_FILTER_TYPE.RADIO &&
      Array.isArray(column.filter_data) &&
      column.filter_data.length > 0
    );
  }

  static getIsFilterableByRuleset(column) {
    const allowedDirections = ["gte", "gt", "eq", "exact", "lt", "lte"];
    const isRulesetObject =
      column?.filter_data &&
      typeof column?.filter_data === "object" &&
      !Array.isArray(column?.filter_data);

    return (
      column?.filter_type === CSV_DATA_FILTER_TYPE.RULESET &&
      isRulesetObject &&
      Object.keys(column?.filter_data).length > 0 &&
      Object.values(column?.filter_data).every(rule => {
        if (!rule || typeof rule !== "object" || Array.isArray(rule)) {
          return false;
        }

        const ruleEntries = Object.entries(rule);

        return (
          ruleEntries.length === 1 &&
          allowedDirections.includes(ruleEntries[0][0])
        );
      })
    );
  }

  static getUserHasAccessToColumn(column, userHasAccess) {
    if (column.is_premium) {
      return userHasAccess;
    }

    return true;
  }

  static getUserHasPermissionToColumn(column, hasPermission) {
    if (column.permissions) {
      return hasPermission(column.permissions);
    }

    return true;
  }

  static getIsDateRange(column) {
    return column.values_type === "date" && this.getIsFilterableByRange(column);
  }

  static resolveFilterColumns(context) {
    const filterColumns =
      context && typeof context.getFilterColumns === "function"
        ? context.getFilterColumns()
        : [];
    const allColumns =
      context && typeof context.getAllAvailableColumns === "function"
        ? context.getAllAvailableColumns()
        : [];
    const seen = new Set();

    return [...filterColumns, ...allColumns].filter(column => {
      if (!column) {
        return false;
      }

      const key =
        column.filtering_attribute_name || column.attribute_name || "";

      if (!key || seen.has(key)) {
        return false;
      }

      seen.add(key);

      return true;
    });
  }

  static findColumnForFiltering(context, filterField) {
    return ApiHelper.resolveFilterColumns(context).find(column =>
      ApiHelper.compareColumnAttributeNameForFiltering(column, filterField)
    );
  }

  static findTrendStatusColumn(context) {
    return ApiHelper.resolveFilterColumns(context).find(column =>
      FilterOptionsHelper.isTrendStatusColumn(column)
    );
  }
}
